import Checkbox from "../../../components/common/checkbox";
import TextInput from "../../../components/common/textinput";
import LABELS from "../../labels/schematics.labels";
interface MotorPerformanceInfo {
    motorHP?: string | number;
    motorVoltage?: string | number;
    motorCurrent?: string | number;
}



export const surfaceEquipment = [
    {
        title: `${LABELS?.surfaceEquip}`,
        dataIndex: "ProjectName",
        key: "text",
        width: "32.5%",
    },
    {
        title: `${LABELS?.pn}`,
        dataIndex: "pn",
        key: "pn",
        width: "30%",
    },
    {
        title: `${LABELS?.weight}`,
        dataIndex: "weight",
        key: "weight",
        width: "30%",
    },
];




export const cableEqipment = [
    {
        title: `${LABELS?.cable}`,
        dataIndex: "ProjectName",
        key: "equipmentName",
        width: "35%",
    },
    {
        title: `${LABELS?.pn}`,
        dataIndex: "pn",
        key: "pn",
        width: "16%",
    },
    {
        title: `${LABELS?.length}`,
        dataIndex: "length",
        key: "length",
        width: "16%",
    },
    {
        title: `${LABELS?.weight}`,
        dataIndex: "weight",
        key: "weight",
        width: "16%",
    },
    {
        title: `${LABELS?.dim}`,
        dataIndex: "diameter",
        key: "diameter",
        width: "16%",
    },
];

export const mleEquipment = [
    {
        title: `${LABELS?.mle}`,
        dataIndex: "equipmentName",
        key: "equipmentName",
        width: "35%",
    },
    {
        title: `${LABELS?.pn}`,
        dataIndex: "pn",
        key: "pn",
        width: "16%",
    },
    {
        title: `${LABELS.length}`,
        dataIndex: "length",
        key: "length",
        width: "16%",
    },
    {
        title: `${LABELS?.weight}`,
        dataIndex: "weight",
        key: "weight",
        width: "16%",
    },
    {
        title: `${LABELS?.dim}`,
        dataIndex: "diameter",
        key: "diameter",
        width: "16%",
    },
];


export const bohEquipment = [
    {
        title: `${LABELS?.boh}`,
        dataIndex: "equipmentName",
        key: "equipmentName",
        width: "35%",
    },
    {
        title: `${LABELS?.pn}`,
        dataIndex: "pn",
        key: "pn",
        width: "13%",
    },
    {
        title: `${LABELS?.length}`,
        dataIndex: "length",
        key: "length",
        width: "13%",
    },
    {
        title: `${LABELS?.weight}`,
        dataIndex: "weight",
        key: "weight",
        width: "13%",
    },
    {
        title: `${LABELS?.diameter}`,
        dataIndex: "diameter",
        key: "diameter",
        width: "13%",
    },
    {
        title: `${LABELS?.setDepth}`,
        dataIndex: "setDepth",
        key: "setDepth",
        width: "13%",
    },
];

export const pumpEquipment = [
    {
        title: `${LABELS?.pump}`,
        dataIndex: "equipmentName",
        key: "equipmentName",
        width: "35%",
    },
    {
        title: `${LABELS?.pn}`,
        dataIndex: "pn",
        key: "pn",
        width: "13%",
    },
    {
        title: `${LABELS?.length}`,
        dataIndex: "length",
        key: "length",
        width: "13%",
    },
    {
        title: `${LABELS?.weight}`,
        dataIndex: "weight",
        key: "weight",
        width: "13%",
    },
    {
        title: `${LABELS?.diameter}`,
        dataIndex: "diameter",
        key: "diameter",
        width: "13%",
    },
    {
        title: `${LABELS?.setDepth}`,
        dataIndex: "setDepth",
        key: "setDepth",
        width: "13%",
    },
];


export const gasHandlingintakeEquipment = [
    {
        title: `${LABELS?.gasHandlingIntake}`,
        dataIndex: "equipmentName",
        key: "equipmentName",
        width: "35%",
    },
    {
        title: `${LABELS?.pn}`,
        dataIndex: "pn",
        key: "pn",
        width: "13%",
    },
    {
        title: `${LABELS?.length}`,
        dataIndex: "length",
        key: "length",
        width: "13%",
    },
    {
        title: `${LABELS?.weight}`,
        dataIndex: "weight",
        key: "weight",
        width: "13%",
    },
    {
        title: `${LABELS?.diameter}`,
        dataIndex: "diameter",
        key: "diameter",
        width: "13%",
    },
    {
        title: `${LABELS?.setDepth}`,
        dataIndex: "setDepth",
        key: "setDepth",
        width: "13%",
    },
];

export const gasSeparatorintakeEquipment = [
    {
        title: `Gas separator`,
        dataIndex: "equipmentName",
        key: "equipmentName",
        width: "35%",
    },
    {
        title: `${LABELS?.pn}`,
        dataIndex: "pn",
        key: "pn",
        width: "13%",
    },
    {
        title: `${LABELS?.length}`,
        dataIndex: "length",
        key: "length",
        width: "13%",
    },
    {
        title: `${LABELS?.weight}`,
        dataIndex: "weight",
        key: "weight",
        width: "13%",
    },
    {
        title: `${LABELS?.diameter}`,
        dataIndex: "diameter",
        key: "diameter",
        width: "13%",
    },
    {
        title: `${LABELS?.setDepth}`,
        dataIndex: "setDepth",
        key: "setDepth",
        width: "13%",
    },
];


export const separatorEquipment = [
    {
        title: `${LABELS?.gasSeparator}`,
        dataIndex: "equipmentName",
        key: "equipmentName",
        width: "35%",
    },
    {
        title: `${LABELS?.pn}`,
        dataIndex: "pn",
        key: "pn",
        width: "13%",
    },
    {
        title: `${LABELS?.length}`,
        dataIndex: "length",
        key: "length",
        width: "13%",
    },
    {
        title: `${LABELS?.weight}`,
        dataIndex: "weight",
        key: "weight",
        width: "13%",
    },
    {
        title: `${LABELS?.diameter}`,
        dataIndex: "diameter",
        key: "diameter",
        width: "13%",
    },
    {
        title: `${LABELS?.setDepth}`,
        dataIndex: "setDepth",
        key: "setDepth",
        width: "13%",
    },
];


export const protectorEquipment = [
    {
        title: `${LABELS?.protectors}`,
        dataIndex: "equipmentName",
        key: "equipmentName",
        width: "35%",
    },
    {
        title: `${LABELS?.pn}`,
        dataIndex: "pn",
        key: "pn",
        width: "13%",
    },
    {
        title: `${LABELS?.length}`,
        dataIndex: "length",
        key: "length",
        width: "13%",
    },
    {
        title: `${LABELS?.weight}`,
        dataIndex: "weight",
        key: "weight",
        width: "13%",
    },
    {
        title: `${LABELS?.diameter}`,
        dataIndex: "diameter",
        key: "diameter",
        width: "13%",
    },
    {
        title: `${LABELS?.setDepth}`,
        dataIndex: "setDepth",
        key: "setDepth",
        width: "13%",
    },
];


export const MotorEquipment = ({ motorHP, motorVoltage, motorCurrent }: MotorPerformanceInfo = {}) => {
    const hpValue = motorHP ?? "--";
    const voltageValue = motorVoltage ?? "--";
    const currentValue = motorCurrent ?? "--";
    return [
        {
            title: `Motor re-rating : Using template HP: ${hpValue}  V: ${voltageValue}  A: ${currentValue}`,
            dataIndex: "equipmentName",
            key: "equipmentName",
            width: "35%",
        },
        {
            title: "Part Number",
            dataIndex: "pn",
            key: "pn",
            width: "13%",
        },
        {
            title: "Length",
            dataIndex: "length",
            key: "length",
            width: "13%",
        },
        {
            title: "Weight",
            dataIndex: "weight",
            key: "weight",
            width: "13%",
        },
        {
            title: "Diameter",
            dataIndex: "diameter",
            key: "diameter",
            width: "13%",
        },
        {
            title: "Set Depth",
            dataIndex: "setDepth",
            key: "setDepth",
            width: "13%",
        },
    ];
};

export const sensorEquipment = [
    {
        title: `Sensor`,
        dataIndex: "equipmentName",
        key: "equipmentName",
        width: "35%",
    },
    {
        title: `${LABELS?.pn}`,
        dataIndex: "pn",
        key: "pn",
        width: "13%",
    },
    {
        title: `${LABELS?.length}`,
        dataIndex: "length",
        key: "length",
        width: "13%",
    },
    {
        title: `${LABELS?.weight}`,
        dataIndex: "weight",
        key: "weight",
        width: "13%",
    },
    {
        title: `${LABELS?.diameter}`,
        dataIndex: "diameter",
        key: "diameter",
        width: "13%",
    },
    {
        title: `${LABELS?.setDepth}`,
        dataIndex: "setDepth",
        key: "setDepth",
        width: "13%",
    },
];

export const belowESPEquipment = [
    {
        title: `${LABELS?.accessoriesBelowESP}`,
        dataIndex: "equipmentName",
        key: "equipmentName",
        width: "35%",
    },
    {
        title: `${LABELS?.pn}`,
        dataIndex: "pn",
        key: "pn",
        width: "13%",
    },
    {
        title: `${LABELS?.length}`,
        dataIndex: "length",
        key: "length",
        width: "13%",
    },
    {
        title: `${LABELS?.weight}`,
        dataIndex: "weight",
        key: "weight",
        width: "13%",
    },
    {
        title: `${LABELS?.setDepth}`,
        dataIndex: "setDepth",
        key: "setDepth",
        width: "13%",
    },
];
export const aboveESPEquipment = [
    {
        title: `${LABELS?.accessoriesAboveESP}`,
        dataIndex: "equipmentName",
        key: "equipmentName",
        width: "35%",
    },
    {
        title: `${LABELS?.pn}`,
        dataIndex: "pn",
        key: "pn",
        width: "13%",
    },
    {
        title: `${LABELS?.length}`,
        dataIndex: "length",
        key: "length",
        width: "13%",
    },
    {
        title: `${LABELS?.weight}`,
        dataIndex: "weight",
        key: "weight",
        width: "13%",
    },
    {
        title: `${LABELS?.diameter}`,
        dataIndex: "diameter",
        key: "diameter",
        width: "13%",
    },
    {
        title: `${LABELS?.setDepth}`,
        dataIndex: "setDepth",
        key: "setDepth",
        width: "13%",
    },
];
export const tailPipeEquipment = [
    {
        title: `${LABELS?.totalJoints}`,
        dataIndex: "tailPipeJoints",
        key: "tailPipeJoints",
        width: "35%",
    },
    
    {
        title: `${LABELS?.length}`,
        dataIndex: "length",
        key: "length",
        width: "13%",
    },
    {
        title: `${LABELS?.weight}`,
        dataIndex: "weight",
        key: "weight",
        width: "13%",
    },
    {
        title: `${LABELS?.setDepth}`,
        dataIndex: "setDepth",
        key: "setDepth",
        width: "13%",
    },
];



interface MiscellaneousProps {
    handleChecked: any;
};
export const miscellaneousReportColumns = [
  {
    title: "Equipment/Accessories",
    dataIndex: "equipmentName",
    key: "equipmentName",
    width: "22%",
  },
  {
    title: `Required`,
    dataIndex: "isRequired",
    key: "isRequired",
    width: "22%",
    render: (_: string, record: { isRequired: boolean }) => (
      <div>
        {record.isRequired === true ? "Yes" : "No"}
      </div>
    ),
  },
  {
    title: `${LABELS.type}`,
    dataIndex: "type",
    key: "type",
    width: "22%",
  },
  {
    title: `${LABELS?.provider}`,
    dataIndex: "provider",
    key: "provider",
    width: "22%",
  },
  {
    title: `${LABELS?.quantity}`,
    dataIndex: "quantity",
    key: "quantity",
    width: "22%",
  },
];


export const miscellaneousColumns = ({ handleChecked }: MiscellaneousProps) => [
    {
        title: "",
        dataIndex: "isRequired",
        key: "isRequired",
        sortable: false,
        width: "10%",
        render: (_: string, record: { isRequired: boolean }, rowIndex: number, colIndex: number) => (
            < div className="flex justify-center">
                <Checkbox
                    label=""
                    checked={record?.isRequired}
                    onChange={(e) => handleChecked(rowIndex, colIndex, e?.target?.checked)}
                    name=""
                />
            </div >
        ),
    },
    {
        title: `${LABELS?.equipmentAccessories}`,
        dataIndex: "equipmentName",
        key: "equipmentName",
        width: "22%",

    },
    {
        title: `${LABELS.type}`,
        dataIndex: "type",
        key: "type",
        width: "22%",
        render: (_: string, record: { type: string }, rowIndex: number, colIndex: number) => (
            <div className="flex justify-center">
                <TextInput
                    label=""
                    onChange={(e) => handleChecked(rowIndex, colIndex, e.target.value)}
                    name=""
                    placeholder="Enter Here"
                    value={record?.type}
                />
            </div>
        ),
    },
    {
        title: `${LABELS?.provider}`,
        dataIndex: "provider",
        key: "provider",
        width: "22%",
        render: (_: string, record: { provider: string }, rowIndex: number, colIndex: number) => (
            <div className="flex justify-center">
                <TextInput
                    label=""
                    onChange={(e) => handleChecked(rowIndex, colIndex, e.target.value)}
                    name=""
                    placeholder="Enter Here"
                    value={record?.provider}
                />
            </div>
        ),
    },
    {
        title: `${LABELS?.quantity}`,
        dataIndex: "quantity",
        key: "quantity",
        width: "22%",
        render: (_: string, record: { quantity: number, equipmentName: string }, rowIndex: number, colIndex: number) => {
            return (
                <>
                    {
                        record?.equipmentName === 'Surface Cable length (ft)' ?
                            <div className="flex justify-center">
                                {record?.quantity}
                            </div> :
                            <div className="flex justify-center">
                                <TextInput
                                    label=""
                                    onChange={(e) => handleChecked(rowIndex, colIndex, e.target.value)}
                                    name=""
                                    placeholder="Enter Here"
                                    value={record?.quantity}
                                />
                            </div>
                    }
                </>

            )
        }
    },
];


export const emptyEquipmentData = [
    {
        id: "1",
        equipmentName: "--",
        projectName: "--",
        pn: "--",
        length: "--",
        weight: "--",
        diameter: "--",
        name: "--",
        od: "--",
        setDepth: "--",
        type: "--",
        provider: "--",
        quantity: "--"
    }
];